import React, { Component } from "react";

import { connect } from "react-redux";
import { _expectPermission } from "_module/utils/ModuleUtils";

class PermittedContent extends Component {
  gPermission() {
    const {
      modulePath,
      expects,
      user: {
        credentials: { sysPermit, orgPermit, orgID },
      },
    } = this.props;

    return _expectPermission(sysPermit, orgPermit, orgID, modulePath, expects);
  }

  render() {
    const { children, elseChildren } = this.props;
    return this.gPermission() ? (
      <>{children}</>
    ) : elseChildren ? (
      <>{elseChildren}</>
    ) : (
      <></>
    );
  }
}

PermittedContent.propTypes = {};
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(PermittedContent);
